import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { ROUTE, EMAIL, SOCIAL } from "../../utils/constants";
import { openLinkInNewTab, openEmail, useNavigation } from "../../utils/functions";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { useIsMobile } from "../../utils/isMobile";

import "./styles.css";
import { PrivacePolicyPopup } from "../../pages/privace-policy";

function Footer() {
  const { t } = useTranslation();
  const [showPolicyPopup, setShowPolicyPopup] = useState(false);

  const openPolicyPopup = (e) => {
    e.preventDefault();
    setShowPolicyPopup(true);
  };

  const closePolicyPopup = () => setShowPolicyPopup(false);

  const isMobile = useIsMobile();
  const goTo = useNavigation();

  if (isMobile) {
    return (
      <div className="footer-container footer-container-mobile">
        <span className="footer-content-text-link" onClick={openPolicyPopup}>
          {t("footer.content.textPolicy")}
        </span>
        <div className="footer-content-social">
          <WhatsAppIcon
            className="footer-content-social-buttom"
            onClick={() => openLinkInNewTab(SOCIAL.whatsapp)}
          />
          <InstagramIcon
            className="footer-content-social-buttom"
            onClick={() => openLinkInNewTab(SOCIAL.instagram)}
          />
          <MailOutlineIcon
            className="footer-content-social-buttom"
            onClick={() => openEmail(EMAIL.contact)}
          />
        </div>
        {showPolicyPopup && (
          <PrivacePolicyPopup closePolicyPopup={closePolicyPopup}></PrivacePolicyPopup>
        )}
      </div>
    );
  }

  return (
    <div className="footer-container">
      <div className="footer-content-text">
        <span>{t("footer.content.textBasilisco")}</span>
        {false ? (
          <>
            <div className="footer-content-text-dot" />
            <span className="footer-content-text-link" onClick={() => goTo(ROUTE.project)}>
              {t("footer.content.textTecnologies")}
            </span>
          </>
        ) : (
          <></>
        )}
        <div className="footer-content-text-dot" />
        <span className="footer-content-text-link" onClick={() => goTo(ROUTE.policy)}>
          {t("footer.content.textPolicy")}
        </span>
        <div className="footer-content-text-dot" />
        <span className="footer-content-text-link" onClick={() => openEmail(EMAIL.contact)}>
          {EMAIL.contact}
        </span>
      </div>
      <div className="footer-content-social">
        <WhatsAppIcon
          className="footer-content-social-buttom"
          onClick={() => openLinkInNewTab(SOCIAL.whatsapp)}
        />
        <InstagramIcon
          className="footer-content-social-buttom"
          onClick={() => openLinkInNewTab(SOCIAL.instagram)}
        />
        <MailOutlineIcon
          className="footer-content-social-buttom"
          onClick={() => openEmail(EMAIL.contact)}
        />
      </div>
    </div>
  );
}

export default Footer;
